// assets/restrizioni-giftcard.js
(function () {
  'use strict';

  const MSG_GIFT_WITH_PRODUCTS =
    'La Gift Card non può essere acquistata insieme ad altri prodotti. Svuota il carrello e riprova.';
  const MSG_PRODUCTS_WITH_GIFT =
    'Non puoi aggiungere altri prodotti se nel carrello è presente una Gift Card. Completa o svuota il carrello prima.';

  function isGiftCardProductPage() {
    return window.location.pathname.indexOf('/products/gift-card') !== -1;
  }

  async function getCart() {
    const res = await fetch('/cart.js', {
      credentials: 'same-origin',
      headers: { Accept: 'application/json' },
      cache: 'no-store',
    });
    if (!res.ok) throw new Error('Errore caricamento carrello');
    return await res.json();
  }

  function cartFlags(cart) {
    const items = Array.isArray(cart && cart.items) ? cart.items : [];
    const cartHasGiftcard = items.some((i) => i && i.gift_card === true);
    const cartHasOtherItems = items.some((i) => i && i.gift_card !== true);
    return { cartHasGiftcard, cartHasOtherItems };
  }

  function hardBlock(e, message) {
    e.preventDefault();
    e.stopPropagation();
    if (typeof e.stopImmediatePropagation === 'function') e.stopImmediatePropagation();
    alert(message);
  }

  function reClick(btn) {
    // Rilancia il click “pulito” dopo che abbiamo dato l’ok
    // evitando loop infinito
    btn.dataset.giftGuardBypass = '1';
    const ev = new MouseEvent('click', { bubbles: true, cancelable: true, view: window });
    btn.dispatchEvent(ev);
    // reset dopo microtask
    Promise.resolve().then(() => {
      delete btn.dataset.giftGuardBypass;
    });
  }

  async function guardAndMaybeReclick(btn, isGiftContext, e) {
    // se è un click “bypass”, non interveniamo
    if (btn && btn.dataset && btn.dataset.giftGuardBypass === '1') return;

    // BLOCCO IMMEDIATO (SYNC) – impedisce a Shella/app di fare add-to-cart subito
    e.preventDefault();
    e.stopPropagation();
    if (typeof e.stopImmediatePropagation === 'function') e.stopImmediatePropagation();

    try {
      const cart = await getCart();
      const { cartHasGiftcard, cartHasOtherItems } = cartFlags(cart);

      // REGOLA 1: sto aggiungendo gift card ma nel carrello ci sono altri prodotti
      if (isGiftContext && cartHasOtherItems) {
        alert(MSG_GIFT_WITH_PRODUCTS);
        return;
      }

      // REGOLA 2: sto aggiungendo prodotto normale ma nel carrello c’è già gift card
      if (!isGiftContext && cartHasGiftcard) {
        alert(MSG_PRODUCTS_WITH_GIFT);
        return;
      }

      // OK: rilancio il click così parte la logica nativa (tema/app)
      reClick(btn);
    } catch (err) {
      // fail-open: se non riesco a leggere il carrello, lascio acquistare
      // ma devo rilanciare il click perché l’abbiamo bloccato sopra
      console.error('giftcard rules · errore lettura carrello:', err);
      reClick(btn);
    }
  }

  function bindButtons() {
    // 1) Pulsanti standard Shella (prodotti normali)
    const nativeButtons = Array.from(
      document.querySelectorAll('button[data-js-product-button-add-to-cart]')
    );

    // 2) Pulsante Gift Card Hero: name="add" type="button" fuori dal form /cart/add
    const giftHeroButtons = Array.from(
      document.querySelectorAll('button[name="add"][type="button"]')
    ).filter((btn) => !btn.closest('form[action*="/cart/add"]'));

    const all = nativeButtons.concat(giftHeroButtons);

    all.forEach((btn) => {
      if (btn.dataset.giftGuardBound === '1') return;
      btn.dataset.giftGuardBound = '1';

      btn.addEventListener(
        'click',
        function (e) {
          const isGiftContext = giftHeroButtons.includes(btn) ? true : isGiftCardProductPage();
          guardAndMaybeReclick(btn, isGiftContext, e);
        },
        true // CAPTURE: prima degli handler tema/app
      );
    });
  }

  function init() {
    bindButtons();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', init);
})();
